/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define(['jquery',
	'../../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'../../../lib/@waca/dashboard-common/dist/utils/Flyout',
	'./FilterFlyoutView',
	'doT',
	'text!./FilterIndicator.html',
	'../../../lib/@waca/dashboard-common/dist/utils/EventChainLocal',
	'../../../widgets/livewidget/nls/StringResources',
	'../../../lib/@waca/core-client/js/core-client/utils/Utils'
], function($, Class, Flyout, FilterFlyoutView, dot, FilterIndicatorTemplate, EventChainLocal, resources, Utils) {
	'use strict';

	var filterTemplate = dot.template(FilterIndicatorTemplate);

	var FilterIndicator = Class.extend({

		init: function(visAPI, visualization, transaction, interactivityController, config, logger, dashboard, content) {
			this.visAPI = visAPI;
			this.config = config;
			this.logger = logger;
			this.transaction = transaction;
			this.interactivityController = interactivityController;
			this.visualization = visualization;
			this.savedPrompts = this.visualization.getSavedPrompts();
			this.dashboard = dashboard;
			this.content = content;
			const filterIcon = this.dashboard.getFeature('Icons').getIcon('filterApplied');

			this.$filter = $(filterTemplate({
				'title': resources.get('widgetFiltersLabel'),
				'iconId': filterIcon.id
			}));
			this.$filter = Utils.embedSVGIcon(this.$filter);
		},

		initEvents: function() {
			var onclick = this._onClick.bind(this);
			this.$filter.on('tap keydown click', onclick);
		},

		remove: function() {
			this.$filter && this.$filter.off() && this.$filter.remove();
			this._clearFlyout();
			this.visAPI = null;
			this.config = null;
			this.$filter = null;
		},

		_clearFlyout: function() {
			if (this.flyout) {
				this.flyout.destroy();
			}
			this.flyout = null;
		},

		setSynchronizeDataFilters: function(synchDataFilterEntries) {
			this.visAPI.setSynchronizeDataFilters(synchDataFilterEntries);
		},

		update: function() {
			this._clearFlyout(); // clear Flyout on update, its info is outdated
			var filters = this.visAPI.getFilterInfo();
			var topBottoms = this.visAPI.getTopBottomInfo();
			var drillState = this.visAPI.getDrillInfo();
			var bContainsPrompts = this.savedPrompts.getPromptSpecList().length;
			const mappingComplete = this.visualization.getSlots().isMappingComplete();
			if (filters || topBottoms || bContainsPrompts || drillState) {
				var localFiltersCount = 0;
				var globalFiltersCount = 0;
				var topBottomsCount = 0;
				var drillStateCount = 0;

				if (filters) {
					localFiltersCount = this.config.localFilters ? filters.localFilters.length : 0;
					if (localFiltersCount) {
						const missingFilters = filters.localFilters.find(localFilter => localFilter.isMissing);
						if (missingFilters) {
							// do not show the filter indicator as the vis view is shown as the static template chart when missing filters
							this.$filter.addClass('dataWidgetFiltersNone');
						}
					}
					globalFiltersCount = this.config.globalFilters ? filters.filters.length : 0;
				}


				if (topBottoms) {
					topBottomsCount = this.config.localTopbottoms ? topBottoms.length : 0;
				}

				if(drillState) {
					drillStateCount = this.config.drillState ? drillState.length : 0;
				}


				var filtersCount = localFiltersCount + globalFiltersCount + topBottomsCount + drillStateCount;
				if ((filtersCount || bContainsPrompts) && mappingComplete) {
					this.$filter.removeClass('dataWidgetFiltersNone');
				} else {
					this.$filter.addClass('dataWidgetFiltersNone');
				}
			}


		},

		isVisible: function() {
			return !this.$filter.hasClass('dataWidgetFiltersNone');
		},

		_preventWidgetContextBar: function(evt) {
			// Set a property in the event that will indicate that we don't want to show the widget toolbar as a result of this event.
			new EventChainLocal(evt).setProperty('preventDefaultContextBar', true);
		},

		_onClick: function(evt) {

			if (evt.keyCode && evt.keyCode !== 13) {
				// Keypress and it is not enter.. ignore
				return;
			}

			if (evt.gesture) {
				// prevent the virtual click event from firing. Otherwise this method will be called twice.
				evt.gesture.preventDefault();
			}
			if (!this.flyout) {
				this.flyout = new Flyout({
					alignment: 'center',
					selector: this.$filter,
					flyoutClass: 'filterPopover visTopPopover',
					viewClass: FilterFlyoutView,
					viewOptions: {
						visController: this.interactivityController,
						visAPI: this.visAPI,
						config: this.config,
						visualization: this.visualization,
						transaction: this.transaction,
						dashboard: this.dashboard,
						content: this.content
					},
					logger: this.logger
				});
			}
			this.flyout.open();
			evt.stopPropagation();
		}

	});

	return FilterIndicator;
});
